const React = require('react');

/* eslint-disable */
module.exports = (props) => {
  return (
    <svg
      viewBox="0 0 36 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`dB w36 ` + (props.className || '')}
    >
      <path
        d="M32.0506 4.48257H30.3712H22.6005H20.9211L19.7826 5.76346L16.1107 9.90499L14.9721 11.1859H13.2927H5.66436H3.98498L5.09508 9.89076L5.62167 9.27878L6.73177 7.98366H5.05238H2.88911H1.67938C0.754299 7.98366 0 8.76643 0 9.70574V13.036V13.3491C0 14.3027 0.754299 15.0712 1.67938 15.0712H2.14904H19.7968H21.0635C21.9885 15.0712 23.2552 14.4877 23.8672 13.7903L26.799 10.46L32.0506 4.48257Z"
        fill="#004E91"
      />
      <path
        d="M34.2853 0.597221C35.2104 0.597221 35.9647 1.37998 35.9647 2.3193V5.96271C35.9647 6.91626 35.2104 7.68479 34.2853 7.68479H33.3744H30.9123H29.2329L30.3572 6.4039L30.9123 5.76346L32.0366 4.48257H20.9071L14.9724 11.1716H3.91406L11.8413 2.20544L12.1402 1.86387C12.7664 1.1665 14.0331 0.582989 14.9581 0.582989H15.3424H34.2853V0.597221Z"
        fill="#FFDD00"
      />
    </svg>
  );
};
